import ClientService from '../../../../services/client-service';
import getUserVerificationDataQuery from '../../../../graphql/query/get-user-verification-data.graphql';
import resendVerificationCodeMutation from '../../../../graphql/mutation/resend-verification-code.graphql';
import verifyUserMutation from '../../../../graphql/mutation/verify-user.graphql';

export default class VerificationApi {
  public static getUserVerificationData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getUserVerificationDataQuery, payload);
  }

  public static resendVerificationCode(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(resendVerificationCodeMutation, payload);
  }

  public static verifyUser(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(verifyUserMutation, payload);
  }
}
